import React, { useState, useEffect } from "react";
import "../../../styles/calculate.css";
//import { PieChart } from 'react-minimal-pie-chart';
import axios from "axios";
import Swal from 'sweetalert2';
import { useNavigate, useParams } from "react-router-dom";
import Loading from 'react-simple-loading';
import { formatWithCommas } from "../../helpers/common";
import { PieChart, Pie, Cell, ResponsiveContainer, Label } from 'recharts';




const Calculate = () => {

    const navigate = useNavigate();
        const params = useParams();
    const contract_id = params.contract_id;

    const [pageLoad, setPageLoad] = useState(true);
    const [contract, setContract] = useState(null);
    const [stipends, setStipends] = useState(null);
    const [benefits, setBenefits] = useState(null);
    const [bonuses, setBonuses] = useState(null);
    const [contractAll, setContractAll] = useState(0.00);
    const [contractPay, setContractPay] = useState(0.00);
    const [contractTakeHomePay, setContractTakeHomePay] = useState(0.00);
    const [dailyTakeHomePay, setDailyTakeHomePay] = useState(0.00);

        const [weeklyAll, setWeeklyAll] = useState(0.00);
    const [weeklyPay, setWeeklyPay] = useState(0.00);
    const [weeklyTakeHomePay, setWeeklyTakeHomePay] = useState(0.00);
    const [weeklyTaxes, setWeeklyTaxes] = useState(0.00);
    const [weeklyStipend, setWeeklyStipend] = useState(0.00);
    const [weeklyBonusAndBenefit, setWeeklyBonusAndBenefit] = useState(0.00);


    const [contractTaxes, setContractTaxes] = useState(0.00);
    const [weeklyHomeStateTaxes, setWeeklyHomeStateTaxes] = useState(0.00);
    const [weeklyStateTaxes, setWeeklyStateTaxes] = useState(0.00);
    const [weeklyFederalTaxes, setWeeklyFederalTaxes] = useState(0.00);
    const [weeklySocialSecurityTaxes, setWeeklySocialSecurityTaxes] = useState(0.00);
    const [weeklyMedicareTaxes, setWeeklyMedicareTaxes] = useState(0.00);
    const [state, setState] = useState(0.00);
    const [homeState, setHomeState] = useState(0.00);


    const [contractStipend, setContractStipend] = useState(0.00);
    const [contractContract, setContractBenefit] = useState(0.00);
    const [contractBonus, setContractBonus] = useState(0.00);


    const [glancePercentage, setGlancePercentage] = useState(false);
    const [stipendPercentage, setStipendPercentage] = useState(false);
    const [bonusPercentage, setBonusPercentage] = useState(false);
    const [taxPercentage, setTaxPercentage] = useState(false);
    const [takeHomePercentage, setTakeHomePercentage] = useState(false);




    const [housingMaxStipendTotal, setHousingMaxStipendTotal] = useState(0.00);
    const [mealsMaxStipendTotal, setMealsMaxStipendTotal] = useState(0.00);
    const [othersMaxStipendTotal, setOthersMaxStipendTotal] = useState(0.00);


    const [housingStipend, setHousingStipend] = useState(0.00);
    const [mealsStipend, setMealsStipend] = useState(0.00);
    const [othersStipend, setOthersStipend] = useState(0.00);
    const [tStipend, setTStipend] = useState(0.00);

    const weeks_in_year = ((new Date().getFullYear()) % 4 == 0) ? 52.28 : 52.1429;
    const days_in_year = ((new Date().getFullYear()) % 4 == 0) ? 365 : 366;
    const social_security_tax = 6.2;
    const medicare_tax = 1.45;

    const purple_colors = ["segment-purple-darker", "segment-purple-dark", "segment-purple", "segment-purple-light", "segment-purple-lighter"]
    const purple_hex_color = ["#4B20B8", "#6444E3", "#907EF9", "#D9D6FE", "#F4F3FF"];


    const pink_colors = ["segment-pink-darker", "segment-pink-dark", "segment-pink", "segment-pink-light", "segment-pink-lighter"]
    const pink_hex_colors = ["#9A0E83", "#E316C7", "#FF6DE9", "#FFCCFA", "#FFF3FD"];

    const brown_colors = ["segment-brown-darker", "segment-brown-dark", "segment-brown", "segment-brown-light", "segment-brown-lighter"]
    const brown_hex_colors = ["#795520", "#E09400", "#FFDE1E", "#FFF787", "#FFFDDC"];

    useEffect(() => {

        document.title = 'Roam Pays: Calculate your tax';
        getContract();
        getStipends();
        getBonuses();
        getBenefits();


    }, []);

    useEffect(() => {

        calculateTakeHomeIncome();

    }, [contract, stipends, benefits, bonuses]);


    const calculateTakeHomeIncome = async () => {

        if (contract && contract.location_id > 0 && contract.duration > 0 && contract.hourly_rate > 0 && contract.shift_schedule_id > 0) {

            setPageLoad(true);
            const hourly_rate = contract.hourly_rate;
            const weekly_hours = contract.days * contract.hours;
            const total_hours = weekly_hours * contract?.duration;
            const total_pay = total_hours * hourly_rate;
            const weekly_pay = weekly_hours * hourly_rate;

            // console.log(weekly_pay);
            const yearly_pay = weekly_pay * weeks_in_year;



            const weekly_stipend = stipends?.reduce((total, { stipend_amount }) => total + stipend_amount, 0);
            const total_stipend = weekly_stipend * contract?.duration;
            const total_bonus = bonuses?.reduce((n, { bonus_amount }) => n + bonus_amount, 0);
            const total_benefit = benefits?.reduce((n, { benefit_amount }) => n + benefit_amount, 0);
            const weekly_bonus_and_benefit = (total_bonus + total_benefit) / contract?.duration;


            const total_pay_including_others = total_pay + total_stipend ;
            setContractAll(total_pay_including_others);


            setWeeklyAll(weekly_pay+weekly_stipend);
            setWeeklyPay(weekly_pay);
            setWeeklyBonusAndBenefit(weekly_bonus_and_benefit);
            setWeeklyStipend(weekly_stipend);


            setContractAll(total_pay+total_stipend);
            setContractPay(total_pay);
            setContractStipend(total_stipend);
            setContractBenefit(total_benefit);
            setContractBonus(total_bonus);

            axios.post(process.env.REACT_APP_API_URL + "/get-taxes", {
                yearly_pay: yearly_pay,
                location_id: contract.location_id,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {

                        setState(response?.data?.state);
                        setHomeState(response?.data?.home_state);

                        const federal_tax = response?.data?.federal_tax;
                        const state_tax = response?.data?.state_tax;
                        const home_state_tax = response?.data?.home_state_tax;

                        const federal_tax_amount = federal_tax / 100 * total_pay
                        const state_tax_amount = state_tax / 100 * total_pay;
                        const home_state_tax_amount = home_state_tax / 100 * total_pay;

                        const social_security_tax_amount = social_security_tax / 100 * total_pay
                        const medicare_tax_amount = medicare_tax / 100 * total_pay

                        const total_tax_amount = federal_tax_amount + state_tax_amount + social_security_tax_amount + medicare_tax_amount;
                        const weekly_federal_tax_amount = federal_tax / 100 * weekly_pay
                        const weekly_state_tax_amount = state_tax / 100 * weekly_pay;
                        const weekly_home_state_tax_amount = home_state_tax / 100 * weekly_pay;

                        const weekly_social_security_tax_amount = social_security_tax / 100 * weekly_pay
                        const weekly_medicare_tax_amount = medicare_tax / 100 * weekly_pay

                        const weekly_total_tax_amount = weekly_federal_tax_amount + weekly_state_tax_amount + weekly_social_security_tax_amount + weekly_medicare_tax_amount;
                        setWeeklyTaxes(weekly_total_tax_amount);


                        setContractTaxes(total_tax_amount);


                        setWeeklyFederalTaxes(weekly_federal_tax_amount);
                        setWeeklyHomeStateTaxes(weekly_home_state_tax_amount);
                        setWeeklyStateTaxes(weekly_state_tax_amount);
                        setWeeklySocialSecurityTaxes(weekly_social_security_tax_amount);
                        setWeeklyMedicareTaxes(weekly_medicare_tax_amount);

                        const total_take_home_pay = total_pay - total_tax_amount;
                        setContractTakeHomePay(total_take_home_pay);


                        const weekly_take_home_pay = total_take_home_pay / contract.duration;
                        setWeeklyTakeHomePay(weekly_take_home_pay);

                        const daily_take_home_pay = (total_take_home_pay + total_stipend) / contract.duration / contract.days;
                        setDailyTakeHomePay(daily_take_home_pay);
                        setPageLoad(false);
                    }


                })
                .catch(function (error) {
                    if (error.status == 403) navigate("/login")
                    else
                        Swal.fire({ icon: "error", title: "Error", text: error.message });

                });




        }

    }

    const getContract = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-contract-by-id/" + contract_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                if (response?.data?.status) {

                    const c = response.data.contract;
                    setContract(c);

                    getPerDiem(c?.city, c?.state_abbreviation, c?.days, c?.duration);

                    //  calculateTakeHomeIncome();
                }
                setPageLoad(false);


            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }

    const getStipends = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-stipends-by-id/" + contract_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                if (response?.data?.status) {


                    setStipends(response?.data?.stipends);
                    let meals_stipend = 0;
                    let housing_stipend = 0;
                    let others_stipend = 0;
                    let total_stipend = 0;

                    response?.data?.stipends?.forEach(function (s) {

                       
                            if (s.tag_title?.toLowerCase() == "meals") {
                                meals_stipend = s.stipend_amount  ;
                            }
                            else if (s.tag_title?.toLowerCase() == "housing") {
                                housing_stipend = s.stipend_amount ;
                            }
                            else {
                                others_stipend = others_stipend + s.stipend_amount;
                            }



                    });



                    setMealsStipend(meals_stipend);
                    setHousingStipend(housing_stipend);
                    setOthersStipend(others_stipend);
                    setTStipend(total_stipend);

                }


            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Stipends", text: error.message });

            });
    }

    const getBenefits = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-benefits-by-id/" + contract_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                setBenefits(response?.data?.benefits);


            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Benefits", text: error.message });

            });
    }

    const getBonuses = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-bonuses-by-id/" + contract_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                setBonuses(response?.data?.bonuses);


            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }

    const getPerDiem = async (city, state, days, duration) => {
    const year = new Date().getFullYear();
    const month = new Date().getMonth(); // 0-based
    const normalizedCity = city ? city.trim().toLowerCase() : "";

    axios
        .get(
            `https://api.gsa.gov/travel/perdiem/v2/rates/city/${encodeURIComponent(city)}/state/${state}/year/${year}?API_KEY=${process.env.REACT_APP_GSA_API_KEY}`
        )
        .then((r) => {
            const rates = r?.data?.rates;
            if (!rates?.length) return;

            const rateEntries = rates[0]?.rate;
            if (!rateEntries?.length) return;

            // Case-insensitive city match
            const matchedRate = rateEntries.find(rt =>
                rt?.city?.toLowerCase().includes(normalizedCity)
            );

            // Fallback: first entry if no match
            const selectedRate = matchedRate || rateEntries[0];

            const housing =
                selectedRate?.months?.month?.[month]?.value ?? 0;

            const meals = selectedRate?.meals ?? 0;

            setHousingMaxStipendTotal(housing * 7);
            setMealsMaxStipendTotal(meals * 7);
        })
        .catch((err) => {
            console.log(err);
        });

    axios
        .get(
            `https://api.gsa.gov/travel/perdiem/v2/rates/conus/mie/${year}?API_KEY=${process.env.REACT_APP_GSA_API_KEY}`
        )
        .then((r) => {
            const rate = r?.data?.[0];
            const others = rate?.incidental ?? 0;
            setOthersMaxStipendTotal(others * 7);
        })
        .catch((err) => {
            console.log(err);
        });
};


    function enforceMinimum(value, minPercent = 2.5) {

        if (value == 0) return 0;
        const all =
            (contractTakeHomePay || 0) +
            (contractTaxes || 0) +
            (contractStipend || 0) +
            (contractContract || 0) +
            (contractBonus || 0);
        const percentage = (value / all) * 100;

        if (percentage < minPercent) {
            const minValue = (minPercent / 100) * all;
            return parseFloat(minValue.toFixed(2));
        }

        return parseFloat(parseFloat(value).toFixed(2));
    }
    const chartData = [
        { name: 'Take-Home', value: enforceMinimum(weeklyTakeHomePay), color: '#A1E312' },
        { name: 'Taxes', value: enforceMinimum(weeklyTaxes), color: '#FCBF04' },
        { name: 'Stipends', value: enforceMinimum(weeklyStipend), color: '#75F' },
      
    ];

    return (
        <>

            <div className="title-box ">
                <div className="flex-equal" >

                    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={() => navigate("/contract/edit/"+contract_id)} >

                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
                        </svg>
                        <label >Back</label>

                    </button>

                </div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white ">Breakdown</h3>
                <div className="flex-equal justify-content-end" > </div>

            </div>

            {pageLoad ?

                <div className="p-32"><Loading color={'#75f'} stroke={'20px'} size={'200px'} /></div>
                :
                <div className="box g-32" >

                    <div className="card" >

                        <div className="card-title" >

                            <div className="box-title color-white fs-18 fs-helvetica" >At a Glance</div>

                        </div>
                        <div className="card-content at-glance-box" >

                            <div className="at-glance" >
                                <div className="chart" >
                                    <div className="donut-chart" >

                                        <ResponsiveContainer>
                                            <PieChart>
                                                <Pie
                                                    data={chartData}
                                                    dataKey="value"
                                                    nameKey="name"
                                                    cx="50%"
                                                    cy="50%"
                                                    innerRadius={78}
                                                    outerRadius={89}
                                                    paddingAngle={2}
                                                    cornerRadius={10}
                                                    labelLine={false}
                                                >
                                                    {chartData.map((entry, index) => (
                                                        <Cell key={`slice-${index}`} fill={entry.color} stroke="none" />
                                                    ))}
                                                </Pie>
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                    <div className="chart-center-label">
                                        <label className="fs-12 color-lighter chart-label">Weekly</label>
                                        <label className="fs-18 color-white chart-amount">${formatWithCommas(weeklyAll)}</label>
                                    </div>
                                </div>
                                <div className="list" >
                                    <div className="list-item" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill="#A1E312" />
                                        </svg>
                                        <label className="color-lighter flex-grow-1 fs-12">Hourly Pay</label>
                                        <label className="color-white  fs-12">{

                                            <>
                                                {"$" + formatWithCommas(parseFloat(weeklyTakeHomePay))}{" "}
                                                {glancePercentage &&
                                                    <span className="color-lighter">
                                                        ({((weeklyTakeHomePay * 100) / weeklyAll).toFixed(2)}%)
                                                    </span>
                                                }
                                            </>
                                        }</label>

                                    </div>
                                    <div className="list-item" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill="#FCBF04" />
                                        </svg>
                                        <label className="color-lighter flex-grow-1 fs-12">Taxes</label>
                                        <label className="color-white  fs-12">
                                            {

                                                <>
                                                    {"$" + formatWithCommas(parseFloat(weeklyTaxes))}{" "}
                                                    {glancePercentage &&

                                                        <span className="color-lighter">
                                                            ({((weeklyTaxes * 100) / weeklyAll).toFixed(2)}%)
                                                        </span>
                                                    }
                                                </>
                                            }

                                        </label>


                                    </div>
                                    <div className="list-item" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill="#7755FF" />
                                        </svg>
                                        <label className="color-lighter flex-grow-1 fs-12">Stipends</label>
                                        <label className="color-white  fs-12">
                                            {
                                                <>
                                                    {"$" + formatWithCommas(parseFloat(weeklyStipend))}{" "}
                                                    {glancePercentage &&

                                                        <span className="color-lighter">
                                                            ({((weeklyStipend * 100) / weeklyAll).toFixed(2)}%)
                                                        </span>
                                                    }
                                                </>
                                            }


                                        </label>


                                    </div>
                                   
                                </div>


                            </div>
                            <div className="action " >
                                <button onClick={() => setGlancePercentage(!glancePercentage)} className={"btn btn-link btn-sm flex-grow-1 "}>Show Percentages</button>
                            </div>

                        </div>
                    </div>


                    <div className="card" >

                        <div className="card-title" >

                            <div className="box-title color-white fs-18 fs-helvetica" >Take-Home Pay</div>



                        </div>
                        <div className="card-content take-home-pay" >


                            <div className="fd-column align-self-stretch">
                                <div className="fd-column g-4">
                                    <div className="color-lighter fs-12" >
                                        Weekly
                                    </div>
                                    <div className="fd-row color-white fs-26" >
                                        <label className="flex-grow-1">${formatWithCommas(weeklyTakeHomePay + weeklyStipend)}</label>
                                        
                                    </div>
                                </div>

                                <div className="d-flex bg-grey border-12" >
                                    <div className="segment segment-green segment-lg" style={{ flex: "0 0 " + (weeklyTakeHomePay * 100 / (weeklyTakeHomePay+weeklyStipend)) + "%" }}  ></div>
                                    <div className="segment segment-purple segment-lg" style={{ flex: "0 0 " + (weeklyStipend * 100 / (weeklyTakeHomePay+weeklyStipend)) + "%" }}  ></div>


                                </div>
                                <div className="p-8 d-flex fs-12 justify-content-end color-lighter" >
                                    <label >Taxable Income: <span className="color-white  ">${formatWithCommas(weeklyPay)}</span></label>

                                </div>

                               


                            </div>


 <div className="fd-row fs-12 g-8 justify-content-space-between align-self-stretch">
                                    <label className="color-light g-8 d-flex align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill="#A1E312" />
                                        </svg>
                                        Weekly Hourly Pay
                                    </label>
                                    <label>
                                        <>
                                            {"$" + formatWithCommas(parseFloat(weeklyTakeHomePay))}{" "}
                                            {takeHomePercentage && (
                                                <span className="color-lighter">
                                                    ({(weeklyTakeHomePay * 100 / (weeklyTakeHomePay+weeklyStipend))?.toFixed(2)}%)
                                                </span>
                                            )}
                                        </>
                                    </label>
                                </div>
                                <div className="fd-row fs-12 g-8 justify-content-space-between align-self-stretch">
                                    <label className="color-light g-8 d-flex align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill="#7755FF" />
                                        </svg>
                                        Weekly Stipend
                                    </label>
                                    <label>
                                        <>
                                            {"$" + formatWithCommas(parseFloat(weeklyStipend))}{" "}
                                            {takeHomePercentage && (
                                                <span className="color-lighter">
                                                    ({(weeklyStipend * 100 / (weeklyTakeHomePay+weeklyStipend))?.toFixed(2)}%)
                                                </span>
                                            )}
                                        </>
                                    </label>
                                </div>
                            <div className="fd-row  g-8 align-self-stretch">
                                <div className="input-container" >

                                    <div className="input-box dir gap-0"  >

                                        <label className="color-light fs-14 gap-0"  ><span className="color-white  ">${formatWithCommas(dailyTakeHomePay)}</span></label>
                                        <label className="color-light fs-12"  >Daily</label>

                                    </div>


                                </div>


                                <div className="input-container " >

                                    <div className="input-box dir gap-0"  >

                                        <label className="color-light fs-14 gap-0"  ><span className="color-white">${formatWithCommas(contractTakeHomePay+contractStipend)}</span></label>
                                        <label className="color-light fs-12"  >Contract Total</label>

                                    </div>
                                </div>
                            </div>

 <div className="action d-flex align-self-stretch " >
                                <button onClick={() => setTakeHomePercentage(!takeHomePercentage)} className={"btn btn-link btn-sm flex-grow-1 "}>Show Percentages</button>
                            </div>



                        </div>



                    </div>




                    <div className="card" >

                        <div className="card-title" >

                            <div className="box-title color-white fs-18 fs-helvetica" >Taxes</div>



                        </div>
                        <div className="card-content take-home-pay" >


                            <div className="fd-column align-self-stretch">
                                <div className="fd-column g-4">
                                    <div className="color-lighter fs-12" >
                                        Weekly
                                    </div>
                                    <div className="fd-row color-white fs-26" >
                                        <label className="flex-grow-1">${formatWithCommas(weeklyTaxes)}</label>
                                        <label>{((weeklyTaxes * 100 / weeklyAll).toFixed(2) + "%")}</label>
                                    </div>
                                </div>

                                <div className="fd-row flex-grow-1">

                                    <div className={"segment segment-lg " + brown_colors[0]} style={{ flex: "0 0 " + (weeklyHomeStateTaxes * 100 / (weeklyTaxes + weeklyHomeStateTaxes)).toFixed(0) + "%" }}  ></div>
                                    <div className={"segment segment-lg " + brown_colors[1]} style={{ flex: "0 0 " + (weeklyStateTaxes * 100 / (weeklyTaxes + weeklyHomeStateTaxes)).toFixed(0) + "%" }}  ></div>
                                    <div className={"segment segment-lg " + brown_colors[2]} style={{ flex: "0 0 " + (weeklyFederalTaxes * 100 / (weeklyTaxes + weeklyHomeStateTaxes)).toFixed(0) + "%" }}  ></div>
                                    <div className={"segment segment-lg " + brown_colors[3]} style={{ flex: "0 0 " + (weeklySocialSecurityTaxes * 100 / (weeklyTaxes + weeklyHomeStateTaxes)).toFixed(0) + "%" }}  ></div>
                                    <div className={"segment segment-lg " + brown_colors[4]} style={{ flex: "0 0 " + (weeklyMedicareTaxes * 100 / (weeklyTaxes + weeklyHomeStateTaxes)).toFixed(0) + "%" }}  ></div>

                                </div>


                            </div>

                            <div className="fd-column align-self-stretch g-16">

                                <div className="fd-row  fs-12 g-8 justify-content-space-between align-self-stretch">

                                    <label className="color-light g-8 d-flex align-items-center">

                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill={brown_hex_colors[0]} />
                                        </svg>

                                        Home State ({homeState})
                                    </label>
                                    <label>


                                        <>
                                            {"$" + formatWithCommas(parseFloat(weeklyHomeStateTaxes))}{" "}
                                            {taxPercentage &&
                                                <span className="color-lighter">
                                                    ({((weeklyHomeStateTaxes * 100) / weeklyTaxes).toFixed(2)}%)
                                                </span>
                                            }
                                        </>



                                    </label>

                                </div>

                                <div className="fd-row  fs-12 g-8 justify-content-space-between align-self-stretch">

                                    <label className="color-light g-8 d-flex align-items-center">

                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill={brown_hex_colors[1]} />
                                        </svg>

                                        Work State ({state})
                                    </label>
                                    <label>


                                        <>
                                            {"$" + formatWithCommas(parseFloat(weeklyStateTaxes))}{" "}
                                            {taxPercentage &&
                                                <span className="color-lighter">
                                                    ({((weeklyStateTaxes * 100) / weeklyTaxes).toFixed(2)}%)
                                                </span>
                                            }

                                        </>

                                    </label>

                                </div>

                                <div className="fd-row  fs-12 g-8 justify-content-space-between align-self-stretch">

                                    <label className="color-light g-8 d-flex align-items-center">

                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill={brown_hex_colors[2]} />
                                        </svg>

                                        Federal
                                    </label>
                                    <label>


                                        <>
                                            {"$" + formatWithCommas(parseFloat(weeklyFederalTaxes))}{" "}
                                            {taxPercentage &&
                                                <span className="color-lighter">
                                                    ({((weeklyFederalTaxes * 100) / weeklyTaxes).toFixed(2)}%)
                                                </span>
                                            }
                                        </>


                                    </label>

                                </div>

                                <div className="fd-row  fs-12 g-8 justify-content-space-between align-self-stretch">

                                    <label className="color-light g-8 d-flex align-items-center">

                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill={brown_hex_colors[3]} />
                                        </svg>

                                        Social Security
                                    </label>
                                    <label>

                                        <>
                                            {"$" + formatWithCommas(parseFloat(weeklySocialSecurityTaxes))}{" "}
                                            {taxPercentage &&
                                                <span className="color-lighter">
                                                    ({((weeklySocialSecurityTaxes * 100) / weeklyTaxes).toFixed(2)}%)
                                                </span>
                                            }
                                        </>

                                    </label>

                                </div>

                                <div className="fd-row  fs-12 g-8 justify-content-space-between align-self-stretch">

                                    <label className="color-light g-8 d-flex align-items-center">

                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill={brown_hex_colors[4]} />
                                        </svg>

                                        Medicare
                                    </label>
                                    <label>


                                        <>
                                            {"$" + formatWithCommas(parseFloat(weeklyMedicareTaxes))}{" "}
                                            {taxPercentage &&
                                                <span className="color-lighter">
                                                    ({((weeklyMedicareTaxes * 100) / weeklyTaxes).toFixed(2)}%)
                                                </span>
                                            }
                                        </>




                                    </label>

                                </div>



                            </div>

                            <div className="action d-flex align-self-stretch" >
                                <button onClick={() => setTaxPercentage(!taxPercentage)} className={"btn btn-link btn-sm flex-grow-1 "}>Show Percentages</button>
                            </div>


                            <div className="action fd-column align-self-stretch g-8" >
                                <div className="w-100"><hr className="color-light" /></div>
                                <div className="fd-row align-items-center " >
                                    <label className="cursor-pointer color-lighter fs-12 bg-transparent flex-grow-1">Taxes are highly accurate, but may not be exact.</label>

                                </div>
                            </div>

                        </div>




                    </div>




                    <div className="card g-16" >

                        <div className="card-title" >

                            <div className="box-title color-white fs-18 fs-helvetica" >Stipends</div>

                        </div>
                        <div className="card-content take-home-pay align-items-stretch g-16" >


                            <div className="fd-column  flex-grow-1">
                                <div className="flex-grow-1 color-lighter fs-12" >
                                    Total
                                </div>
                                <div className="flex-grow-1 color-white fs-26 d-flex" >

                                    <label className="flex-grow-1">${formatWithCommas(weeklyStipend)}</label>
                                    <label>{((weeklyStipend * 100 / weeklyAll).toFixed(2) + "%")}</label>
                                </div>

                                <div className="fd-row flex-grow-1">
                                    {stipends && stipends.map((s, index) => {
                                        // Calculate adjusted amount based on tag_title

                                        const percentage = (s.stipend_amount  * 100 / weeklyStipend).toFixed(0);

                                        return (
                                            <div
                                                key={index}
                                                className={"segment segment-lg " + purple_colors[index]}
                                                style={{ flex: "0 0 " + percentage + "%" }}
                                            ></div>
                                        );
                                    })}

                                </div>

                            </div>

                            {stipends && stipends.map((s, index) => {
                                const isTotalTag = s.tag_title?.toLowerCase() === 'total';
                             
                                const percentage = stipendPercentage
                                    ? ((s.stipend_amount  * 100) / weeklyStipend).toFixed(2)
                                    : null;

                                return (
                                    <div key={index} className="fd-row fs-12 g-8 justify-content-space-between align-self-stretch">
                                        <label className="color-light g-8 d-flex align-items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill={purple_hex_color[index]} />
                                            </svg>
                                            {s.tag_title}
                                        </label>
                                        <label>
                                            <>
                                                {"$" + formatWithCommas(parseFloat(s.stipend_amount ))}{" "}
                                                {percentage && (
                                                    <span className="color-lighter">
                                                        ({percentage}%)
                                                    </span>
                                                )}
                                            </>
                                        </label>
                                    </div>
                                );
                            })}


                            <div className="action d-flex align-self-stretch" >
                                <button onClick={() => setStipendPercentage(!stipendPercentage)} className={"btn btn-link btn-sm flex-grow-1 "}>Show Percentages</button>
                            </div>

                            <div className="w-100"><hr className="color-light" /></div>




                            <div className="" >

                                <div className="box-title color-white fs-18 fs-helvetica" >Max Allowances</div>



                            </div>

                          


                            {(housingStipend && housingStipend > 0) ?

                                <div className="fd-column  g-4">
                                    <div className="w-100 color-light fs-12" >
                                        Housing
                                    </div>
                                    <div className="w-100 color-white fs-16 d-flex" >

                                        <label className="flex-grow-1 align-items-center ">${formatWithCommas(housingStipend)}</label>

                                        {(housingStipend == housingMaxStipendTotal) ?
                                            <button className="btn btn-sm btn-out fd-row align-items-center g-8">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00008C12.8337 3.77842 10.222 1.16675 7.00033 1.16675C3.77866 1.16675 1.16699 3.77842 1.16699 7.00008C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334ZM5.14363 6.33093L4.31867 7.15588L6.38107 9.21828L9.6809 5.91845L8.85594 5.09349L6.38107 7.56836L5.14363 6.33093Z" fill="#BDEA5C" />
                                                </svg>
                                                <label>Maxed Out</label>
                                            </button>
                                            :
                                            <>
                                                {housingStipend > housingMaxStipendTotal ?
                                                    <button className="btn btn-sm btn-over fd-row align-items-center g-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FFED48" />
                                                        </svg>
                                                        <label>${formatWithCommas(housingStipend - housingMaxStipendTotal)} Over</label>
                                                    </button>
                                                    :
                                                    <button className="btn btn-sm btn-under fd-row align-items-center g-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FF9696" />
                                                        </svg>
                                                        <label>${formatWithCommas(housingMaxStipendTotal - housingStipend)} Under</label>
                                                    </button>
                                                }
                                            </>
                                        }

                                    </div>


                                    <div className="d-flex bg-grey border-12" >
                                        {(housingStipend == housingMaxStipendTotal) ?
                                            <div className="segment segment-green " style={{ flex: "0 0 " + (housingStipend >= housingMaxStipendTotal ? 100 : (housingStipend * 100 / housingMaxStipendTotal)) + "%" }}  ></div>
                                            :
                                            <>
                                                {(housingStipend > housingMaxStipendTotal) ?
                                                    <div className="segment segment-brown " style={{ flex: "0 0 " + (housingStipend >= housingMaxStipendTotal ? 100 : (housingStipend * 100 / housingMaxStipendTotal)) + "%" }}  ></div>
                                                    :
                                                    <div className="segment segment-red " style={{ flex: "0 0 " + (housingStipend >= housingMaxStipendTotal ? 100 : (housingStipend * 100 / housingMaxStipendTotal)) + "%" }}  ></div>
                                                }
                                            </>
                                        }
                                    </div>
                                    <div className="p-8 d-flex fs-12 justify-content-end color-light" >
                                        <label >Maximum Allowance: <span className="color-white  ">${formatWithCommas(housingMaxStipendTotal)}</span></label>

                                    </div>
                                </div>

                                :
                                <></>

                            }

                            {(mealsStipend && mealsStipend > 0) ?

                                <div className="fd-column  g-4">
                                    <div className="w-100 color-light fs-12" >
                                        Meals
                                    </div>
                                    <div className="w-100 color-white fs-16 d-flex" >

                                        <label className="flex-grow-1 align-items-center ">${formatWithCommas(mealsStipend)}</label>

                                        {(mealsStipend == mealsMaxStipendTotal) ?
                                            <button className="btn btn-sm btn-out fd-row align-items-center g-8">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00008C12.8337 3.77842 10.222 1.16675 7.00033 1.16675C3.77866 1.16675 1.16699 3.77842 1.16699 7.00008C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334ZM5.14363 6.33093L4.31867 7.15588L6.38107 9.21828L9.6809 5.91845L8.85594 5.09349L6.38107 7.56836L5.14363 6.33093Z" fill="#BDEA5C" />
                                                </svg>
                                                <label>Maxed Out</label>
                                            </button>
                                            :
                                            <>
                                                {mealsStipend > mealsMaxStipendTotal ?
                                                    <button className="btn btn-sm btn-over fd-row align-items-center g-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FFED48" />
                                                        </svg>
                                                        <label>${formatWithCommas(mealsStipend - mealsMaxStipendTotal)} Over</label>
                                                    </button>
                                                    :
                                                    <button className="btn btn-sm btn-under fd-row align-items-center g-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FF9696" />
                                                        </svg>
                                                        <label>${formatWithCommas(mealsMaxStipendTotal - mealsStipend)} Under</label>
                                                    </button>
                                                }
                                            </>
                                        }

                                    </div>


                                    <div className="d-flex bg-grey border-12" >

                                        {(mealsStipend == mealsMaxStipendTotal) ?
                                            <div className="segment segment-green " style={{ flex: "0 0 " + (mealsStipend >= mealsMaxStipendTotal ? 100 : (mealsStipend * 100 / mealsMaxStipendTotal)) + "%" }}  ></div>
                                            :
                                            <>
                                                {(mealsStipend > mealsMaxStipendTotal) ?
                                                    <div className="segment segment-brown " style={{ flex: "0 0 " + (mealsStipend >= mealsMaxStipendTotal ? 100 : (mealsStipend * 100 / mealsMaxStipendTotal)) + "%" }}  ></div>
                                                    :
                                                    <div className="segment segment-red " style={{ flex: "0 0 " + (mealsStipend >= mealsMaxStipendTotal ? 100 : (mealsStipend * 100 / mealsMaxStipendTotal)) + "%" }}  ></div>
                                                }
                                            </>
                                        }
                                    </div>
                                    <div className="p-8 d-flex fs-12 justify-content-end color-light" >
                                        <label >Maximum Allowance: <span className="color-white  ">${formatWithCommas(mealsMaxStipendTotal)}</span></label>

                                    </div>
                                </div>

                                :
                                <></>

                            }

                            {(othersStipend && othersStipend > 0) ?

                                <div className="fd-column  g-4">
                                    <div className="w-100 color-light fs-12" >
                                        Others
                                    </div>
                                    <div className="w-100 color-white fs-16 d-flex" >

                                        <label className="flex-grow-1 align-items-center ">${formatWithCommas(othersStipend)}</label>

                                        {(othersStipend == othersMaxStipendTotal) ?
                                            <button className="btn btn-sm btn-out fd-row align-items-center g-8">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00008C12.8337 3.77842 10.222 1.16675 7.00033 1.16675C3.77866 1.16675 1.16699 3.77842 1.16699 7.00008C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334ZM5.14363 6.33093L4.31867 7.15588L6.38107 9.21828L9.6809 5.91845L8.85594 5.09349L6.38107 7.56836L5.14363 6.33093Z" fill="#BDEA5C" />
                                                </svg>
                                                <label>Maxed Out</label>
                                            </button>
                                            :
                                            <>
                                                {othersStipend > othersMaxStipendTotal ?
                                                    <button className="btn btn-sm btn-over fd-row align-items-center g-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FFED48" />
                                                        </svg>
                                                        <label>${formatWithCommas(othersStipend - othersMaxStipendTotal)} Over</label>
                                                    </button>
                                                    :
                                                    <button className="btn btn-sm btn-under fd-row align-items-center g-8">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FF9696" />
                                                        </svg>
                                                        <label>${formatWithCommas(othersMaxStipendTotal - othersStipend)} Under</label>
                                                    </button>
                                                }
                                            </>
                                        }

                                    </div>

                                    <div className="d-flex bg-grey border-12" >
                                        {(othersStipend == othersMaxStipendTotal) ?
                                            <div className="segment segment-green " style={{ flex: "0 0 " + (othersStipend >= othersMaxStipendTotal ? 100 : (othersStipend * 100 / othersMaxStipendTotal)) + "%" }}  ></div>
                                            :
                                            <>
                                                {(othersStipend > othersMaxStipendTotal) ?
                                                    <div className="segment segment-brown " style={{ flex: "0 0 " + (othersStipend >= othersMaxStipendTotal ? 100 : (othersStipend * 100 / othersMaxStipendTotal)) + "%" }}  ></div>
                                                    :
                                                    <div className="segment segment-red " style={{ flex: "0 0 " + (othersStipend >= othersMaxStipendTotal ? 100 : (othersStipend * 100 / othersMaxStipendTotal)) + "%" }}  ></div>
                                                }
                                            </>
                                        }
                                    </div>
                                    <div className="p-8 d-flex fs-12 justify-content-end color-light" >
                                        <label >Maximum Allowance: <span className="color-white  ">${formatWithCommas(othersMaxStipendTotal)}</span></label>

                                    </div>

                                    <div className="p-4" >
                                        <hr className="hr-grey" />
                                    </div>

                                    <div className="p-8 d-flex fs-12 color-lighter" >
                                        Max allowances are based on GSA.gov rates.
                                    </div>
                                </div>
                                :
                                <></>

                            }

                        </div>





                    </div>





                    <div className="card g-16" >

                        <div className="card-title" >

                            <div className="box-title color-white fs-18 fs-helvetica" >Bonuses</div>



                        </div>
                        <div className="card-content take-home-pay align-items-stretch g-16" >


                            <div className="fd-column  flex-grow-1">
                                <div className="flex-grow-1 color-lighter fs-12" >
                                    Total
                                </div>
                                <div className="flex-grow-1 color-white fs-26 d-flex" >

                                    <label className="flex-grow-1">${formatWithCommas(parseFloat(contractBonus))}</label>
                                    <label>{((contractBonus * 100 / contractAll).toFixed(2) + "%")}</label>
                                </div>

                                <div className="fd-row flex-grow-1">

                                    {bonuses && bonuses.map((s, index) => {
                                        return <div className={"segment segment-lg " + pink_colors[index]} style={{ flex: "0 0 " + (s.bonus_amount * 100 / contractBonus).toFixed(0) + "%" }}  ></div>

                                    })
                                    }

                                </div>

                            </div>


                            {bonuses && bonuses.map((s, index) => {
                                return <div className="fd-row  fs-12 g-8 justify-content-space-between align-self-stretch">

                                    <label className="color-light g-8 d-flex align-items-center">

                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z" fill={pink_hex_colors[index]} />
                                        </svg>

                                        {s.tag_title}
                                    </label>
                                    <label>


                                        <>
                                            {"$" + formatWithCommas(parseFloat(s.bonus_amount))}{" "}
                                            {bonusPercentage &&

                                                <span className="color-lighter">
                                                    ({((s.bonus_amount * 100) / contractBonus).toFixed(2)}%)
                                                </span>
                                            }
                                        </>


                                    </label>

                                </div>

                            })
                            }
                            <div className="action d-flex align-self-stretch" >
                                <button onClick={() => setBonusPercentage(!bonusPercentage)} className={"btn btn-link btn-sm flex-grow-1 "}>Show Percentages</button>
                            </div>







                        </div>





                    </div>
                    <br /><br />
                </div>

            }

        </>


    );
};

export default Calculate;